import RecommendedPercentage from 'components/Dealer/About/Ratings/RecommendedPercentage';
import OverallRating from 'components/Dealer/About/Ratings/OverallRating';
import RatingBreakdown from 'components/Dealer/About/Ratings/RatingBreakdown';
import SubmitReview from 'components/Dealer/About/Ratings/SubmitReview';
import styles from './styles';

interface RatingProps {
  recommendedPercentage: number | null;
  averageOverallStars: number | null;
  totalReviews: number;
  averagePricingStars: number | null;
  averageServiceStars: number | null;
  averageHelpfulnessStars: number | null;
  averageResponsivenessStars: number | null;
}

export default function Ratings({
  recommendedPercentage,
  averageOverallStars,
  totalReviews,
  averagePricingStars,
  averageServiceStars,
  averageHelpfulnessStars,
  averageResponsivenessStars,
}: RatingProps): JSX.Element {
  return (
    <div className="rating-section">
      <div className="rating-summary">
        <div className="top-section">
          <div className="recommendation-percentage">
            <RecommendedPercentage percentage={recommendedPercentage || 0} />
          </div>
          <div className="overall-experience">
            <OverallRating rating={averageOverallStars || 0} count={totalReviews || 0} />
          </div>
        </div>
        <div className="bottom-section">
          <RatingBreakdown
            pricing={averagePricingStars || 0}
            service={averageServiceStars || 0}
            helpfulness={averageHelpfulnessStars || 0}
            responsiveness={averageResponsivenessStars || 0}
          />
        </div>
      </div>
      <div className="submit-review">
        <SubmitReview />
      </div>
      <style jsx>{styles}</style>
    </div>
  );
}
